<form
  class="input-search-modal-form"
  [class.active]="inputControl.value"
  ngNoForm
  (submit)="$event.preventDefault()"
  data-analytics="search_form"
>
  <input
    #inputModalSearch
    id="inputModalSearch"
    type="text"
    class="input-search-modal-input text-h6-s text-lg-h6-m"
    autocapitalize="off"
    aria-label="search"
    autocomplete="off"
    autocorrect="off"
    enterkeyhint="search"
    spellcheck="false"
    [placeholder]="placeholder"
    [formControl]="inputControl"
    (keydown.enter)="enterSearchInput.emit()"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
  />
  @if (isLoading && inputControl.value) {
    <sd-loader class="input-search-modal-right-side" theme="orange" size="m"></sd-loader>
  } @else if (inputControl.value) {
    <button
      class="input-search-modal-right-side btn-reset color-black-warm-600 btn-icon"
      aria-label="reset"
      tabindex="0"
      type="button"
      (click)="inputModalSearch.blur(); clear.emit()"
    >
      <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.CROSS"></sd-icon>
    </button>
  } @else {
    <button
      class="input-search-modal-right-side btn-search color-black-warm-600 btn-icon"
      aria-label="search"
      tabindex="0"
      type="submit"
      (click)="inputModalSearch.focus()"
    >
      <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.SEARCH"></sd-icon>
    </button>
  }
</form>
